import { TagVariant } from './Tag';
import { Theme, css } from '@emotion/react';
import { assertNever } from '@tock/shared/utils/typeUtils';

export const tagBase = ({ spacing }: Theme, isRemovable: boolean) => css`
  border: 1px solid;
  border-radius: 32px;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  padding-left: ${spacing(2)}px;
  padding-right: ${isRemovable ? spacing(1) : spacing(2)}px;
  position: relative;
  height: 44px;

  & button {
    margin-left: ${spacing(1.5)}px;
  }

  & button::before {
    bottom: ${spacing(-1)}px;
    border-radius: 44px;
    content: '';
    left: ${spacing(-1)}px;
    position: absolute;
    right: ${spacing(-1)}px;
    top: ${spacing(-1)}px;
  }
`;

export const tagVariant = ({ colors }: Theme, tagVariant: TagVariant) => {
  switch (tagVariant) {
    case 'basic':
      return css`
        background-color: ${colors.bgDefault};
        border-color: ${colors.borderDefault};
        color: ${colors.fgDefault};
      `;
    case 'highContrast':
      return css`
        background-color: ${colors.bgDark};
        border-color: ${colors.bgDark};
        color: ${colors.fgContrast};
      `;
    default:
      assertNever(tagVariant);
  }
};

export const tagContent = ({ typography }: Theme) => css`
  ${typography.variant('body02Strong')};
`;
